import Vue from "vue";
/* registrando os componentes */
Vue.component("spinner", require("./shared/loader.vue").default);

Vue.component("topbar", require("./shared/top-bar.vue").default);
Vue.component("menu3v3", require("./shared/menu.vue").default);
Vue.component("side-bar", require("./shared/side-bar.vue").default);
Vue.component("bottom-bar", require("./shared/bottom-bar.vue").default);
Vue.component(
  "general-warning",
  require("./shared/general-warning.vue").default
);

Vue.component("toolbar", require("./shared/tool-bar.vue").default);

Vue.component(
  "schedule-details",
  require("../monitoringPages/Schedules/components/ScheduleDetails.vue").default
);
Vue.component(
  "sensor-details",
  require("../monitoringPages/Sensors/components/SensorDetails.vue").default
);
Vue.component(
  "dirs-details",
  require("../monitoringPages/Dirs/components/DirDetails.vue").default
);
Vue.component(
  "actuator-details",
  require("../monitoringPages/Actuators/components/ActuatorDetails.vue").default
);

Vue.component(
  "chart-station",
  require("../monitoringPages/Station/components/StationCharts.vue").default
);

Vue.component(
  "report-form",
  require("../monitoringPages/Reports/components/ReportForm.vue").default
);
Vue.component(
  "chart-form",
  require("../monitoringPages/Charts/components/ChartForm.vue").default
);

Vue.component(
  "schedule-levels",
  require("../registerPages/Schedules/components/ScheduleLevels.vue").default
);
Vue.component(
  "schedule-pdf",
  require("../registerPages/Schedules/components/SchedulePdf.vue").default
);

Vue.component(
  "route-tree",
  require("../registerPages/Routes/components/RouteTree.vue").default
);
Vue.component(
  "node",
  require("../registerPages/Routes/components/RouteBranch.vue").default
);

Vue.component(
  "actuator-form",
  require("../registerPages/Equipments/components/ActuatorForm.vue").default
);
Vue.component(
  "hydro-form",
  require("../registerPages/Equipments/components/HydroForm.vue").default
);
Vue.component(
  "sensor-form",
  require("../registerPages/Equipments/components/SensorForm.vue").default
);
Vue.component(
  "pump-form",
  require("../registerPages/Equipments/components/PumpForm.vue").default
);
Vue.component(
  "actuator-model-form",
  require("../registerPages/Equipments/components/ActuatorModelForm.vue")
    .default
);
Vue.component(
  "sensor-model-form",
  require("../registerPages/Equipments/components/SensorModelForm.vue").default
);
Vue.component(
  "hydro-model-form",
  require("../registerPages/Equipments/components/HydroModelForm.vue").default
);

Vue.component(
  "dir-form",
  require("../registerPages/Dirs/components/DirForm.vue").default
);
Vue.component(
  "dir-model-form",
  require("../registerPages/Dirs/components/DirModelForm.vue").default
);
Vue.component(
  "show-models",
  require("../registerPages/Dirs/components/ShowModels.vue").default
);
Vue.component(
  "mtd-form",
  require("../registerPages/Dirs/components/MTDform.vue").default
);

Vue.component(
  "schedule-form",
  require("../registerPages/Schedules/components/ScheduleForm.vue").default
);

Vue.component(
  "sector-form",
  require("../registerPages/Sectors/components/SectorForm.vue").default
);
//Manejo ---
//Solo
Vue.component(
  "soil-form",
  require("../registerPages/Management/components/SoilForm.vue").default
);
//Adubo
Vue.component(
  "fertilizer-form",
  require("../registerPages/Management/components/FertilizerForm.vue").default
);
//Cultivar
Vue.component(
  "farm-form",
  require("../registerPages/Management/components/FarmForm.vue").default
);
//
Vue.component(
  "user-form",
  require("../registerPages/Users/components/UserForm.vue").default
);
Vue.component(
  "group-form",
  require("../registerPages/Users/components/GroupForm.vue").default
);
